import React from 'react';
import { Phone, Mail, MapPin, Clock, MessageCircle } from 'lucide-react';
import { contactInfo } from '../data/mock';
import MultiStepContactForm from './MultiStepContactForm';

const ContactSection = () => {
  return (
    <section id="contact" className="relative bg-[#050505] py-32 overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-grid-pattern opacity-[0.02]" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-accent/5 rounded-full blur-[200px]" />
      <div className="absolute top-1/4 left-0 w-[400px] h-[400px] bg-violet-500/5 rounded-full blur-[200px]" />

      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-accent text-sm font-medium tracking-wider uppercase mb-4 block">
            Contact
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-white mb-6 leading-tight">
            Parlons de votre{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-accent to-violet-400">
              projet
            </span>
          </h2>
          <p className="text-white/50 text-lg max-w-2xl mx-auto">
            Prêt à donner vie à votre projet digital ? Complétez notre formulaire en quelques étapes pour obtenir un devis personnalisé.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {/* Left - Contact Info */}
          <div className="lg:col-span-1 space-y-6">
            {/* Quick Contact */}
            <div className="bg-white/[0.02] border border-white/[0.05] p-6">
              <h3 className="text-white font-semibold mb-6 flex items-center gap-2">
                <MessageCircle size={18} className="text-accent" />
                Contact direct
              </h3>
              
              <div className="space-y-4">
                <a
                  href={`tel:${contactInfo.phone.replace(/\s/g, '')}`}
                  className="group flex items-center gap-4 p-3 bg-white/[0.02] hover:bg-accent/10 transition-all duration-300"
                >
                  <div className="w-10 h-10 flex items-center justify-center bg-accent/10 text-accent group-hover:bg-accent group-hover:text-black transition-all duration-300">
                    <Phone size={18} />
                  </div>
                  <div>
                    <div className="text-white/40 text-xs">Téléphone</div>
                    <div className="text-white text-sm font-medium group-hover:text-accent transition-colors">
                      {contactInfo.phone}
                    </div>
                  </div>
                </a>

                <a
                  href={`mailto:${contactInfo.email}`}
                  className="group flex items-center gap-4 p-3 bg-white/[0.02] hover:bg-accent/10 transition-all duration-300"
                >
                  <div className="w-10 h-10 flex items-center justify-center bg-accent/10 text-accent group-hover:bg-accent group-hover:text-black transition-all duration-300">
                    <Mail size={18} />
                  </div>
                  <div>
                    <div className="text-white/40 text-xs">Email</div>
                    <div className="text-white text-sm font-medium group-hover:text-accent transition-colors">
                      {contactInfo.email}
                    </div>
                  </div>
                </a>

                <div className="flex items-center gap-4 p-3 bg-white/[0.02]">
                  <div className="w-10 h-10 flex items-center justify-center bg-accent/10 text-accent">
                    <MapPin size={18} />
                  </div>
                  <div>
                    <div className="text-white/40 text-xs">Localisation</div>
                    <div className="text-white text-sm font-medium">{contactInfo.address}</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Response Time */}
            <div className="bg-gradient-to-br from-accent/10 to-violet-500/10 border border-accent/20 p-6">
              <div className="flex items-center gap-3 mb-3">
                <Clock size={20} className="text-accent" />
                <h4 className="text-white font-medium">Réponse rapide</h4>
              </div>
              <p className="text-white/60 text-sm leading-relaxed">
                Notre équipe analyse chaque demande avec attention. Nous vous recontactons généralement sous <span className="text-accent font-medium">24-48h</span>.
              </p>
            </div>

            {/* Trust Badges */}
            <div className="bg-white/[0.02] border border-white/[0.05] p-6">
              <h4 className="text-white/70 text-sm mb-4">Ils nous font confiance</h4>
              <div className="grid grid-cols-3 gap-3">
                {[1, 2, 3].map((i) => (
                  <div key={i} className="aspect-video bg-white/[0.05] flex items-center justify-center">
                    <span className="text-white/20 text-xs">Logo {i}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right - Multi-Step Form */}
          <div className="lg:col-span-2">
            <MultiStepContactForm />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
